/*******************************************************************************************
   _____            __              ____   ____                         .__               
  /  _  \   _______/  |________  ___\   \ /   /____   ____  __ __  _____|__|____    ____  
 /  /_\  \ /  ___/\   __\_  __ \/  _ \   Y   // __ \ /    \|  |  \/  ___/  \__  \  /    \ 
/    |    \\___ \  |  |  |  | \(  <_> )     /\  ___/|   |  \  |  /\___ \|  |/ __ \|   |  \
\____|__  /____  > |__|  |__|   \____/ \___/  \___  >___|  /____//____  >__(____  /___|  /
        \/     \/                                 \/     \/           \/        \/     \/ 
********************************************************************************************
Markdown Component
********************************************************************************************

Author:     Nicholas Hamilton, PhD
Email:      nicholasehamilton@gmail.com
Date:       17th April 2025

*******************************************************************************************/
import React                            from 'react';
import {
    Box,
    /*
    List,
    ListItem,
    ListItemText,
    */
    Typography
}                                       from '@mui/material';
import ReactMarkdown                    from 'react-markdown';
// import remarkGfm                        from 'remark-gfm';

/*
const markdownContent = `
# Hello Markdown 👋

This is **bold**, _italic_, and a [link](https://example.com).
`;
*/

const HEADING_MAP = {
    h1: 'h4',
    h2: 'h5',
    h3: 'h6',
    h4: 'subtitle1',
    h5: 'subtitle2',
    h6: 'body1'
};

export const Markdown = ({children}) => {
    return (
        <ReactMarkdown
            // remarkPlugins   = {[remarkGfm]}  // Add remark-gfm plugin to enable link parsing
            components      = {{
                ...(
                    Object.entries(HEADING_MAP).reduce((acc, [tag, variant]) => {
                        acc[tag] = ({ node, ...props }) => (
                          <Typography component={tag} variant={variant} {...props} />
                        );
                        return acc;
                      }, {})
                ),
                p: ({node, ...props}) => (
                    <Typography variant="body1" paragraph {...props} />
                ),
                a: ({ node, children, ...props }) => (
                    <Typography
                        component   = "a"
                        {...props}
                        target      = "_blank"
                        rel         = "noopener noreferrer"
                    >
                        {children}
                    </Typography>
                ),
                ul: ({ node, ...props }) => (
                    <Box
                      component="ul"
                      sx={{
                        pl: 4,
                        listStyleType: 'disc',
                        '& li': {
                          display: 'list-item',
                        },
                      }}
                      {...props}
                    />
                  ),
                  ol: ({ node, ...props }) => (
                    <Box
                      component="ol"
                      sx={{
                        pl: 4,
                        listStyleType: 'decimal',
                        '& li': {
                          display: 'list-item',
                        },
                      }}
                      {...props}
                    />
                  ),
                  li: ({ node, ...props }) => (
                    <Typography component="li" variant="body1" {...props} />
                  ),
            }}
        >
            {children}
        </ReactMarkdown>
    )
}

export default Markdown;